module.exports = __webpack_public_path__ + "img/Clutch disc.c8f7724d.jpg";